module.exports = __webpack_public_path__ + "img/36.f09a0ee5.webp";